export const TYPE_KEY = "@WorksheetEditor/";

export const WS_GET_LOCK = `${TYPE_KEY}WS_GET_LOCK`;
export const WS_CREATE = `${TYPE_KEY}WS_CREATE`;
export const WS_IMPORT = `${TYPE_KEY}WS_IMPORT`;
export const WS_FETCH = `${TYPE_KEY}WS_FETCH`;
export const WS_UPDATE = `${TYPE_KEY}WS_UPDATE`;
export const WS_DELETE_FROM_FIELD = `${TYPE_KEY}WS_DELETE_FROM_FIELD`;
